import React from 'react';

const EmailProtection = ({address}) => {
    let user = address.split('@')[0].split('').reverse().join('');
    let domain = address.split('@')[1].split('').reverse().join('');

    return (
        <span data-contact-protection data-contact-user={user} data-contact-domain={domain} />
    )
};

export default EmailProtection;


// WEBPACK FOOTER //
// ./src/components/email-protection/index.js